export const INTEGRATION_TRIGGER = {
  PAYMENT_POSTED: "PAYMENT_POSTED",
  VENDOR_CREATED: "VENDOR_CREATED",
};
